import { makeStyles } from '@material-ui/core'

export const usePortalHomeStyles = makeStyles((theme) => ({
  dashboardContainer: {
    display: 'flex',
    gap: theme.spacing(4),
    flexWrap: 'wrap',
    paddingTop: theme.spacing(4),
    justifyContent: 'space-around',
    '& .dashboard-widget': {
      // width: '100%',
      flex: '1 1 auto',
      maxWidth: `${810}px`,
    },
    height: 'calc(100vh - 152px)',
    overflowY: 'auto',
  },
  filter: {
    // width: '100% ',
    textAlign: 'right',
    alignSelf: 'flex-end',
  },
  kanbanContainer: {
    width: '100vw',
    overflowX: 'auto',
    overflowY: 'hidden',
    height: 'calc(100vh - 152px)',
  },
  createProjectContainer: {
    maxHeight: 'calc(100vh - 152px)',
    overflowY: 'auto',
  },
}))
